import React from "react";
import "./quickviewProductDetails.css";
import { FaShoppingBag } from "react-icons/fa";
import { IoShareOutline } from "react-icons/io5";
import { CiHeart } from "react-icons/ci";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
const Action = ({copyToClipboard,addToCart,addToWishList,isWishlistLoading}) => {
  let preOrder = 0;
  
  return (
    <div className="d-flex gap-3 flex-wrap">
      {preOrder === 1 ? (
        <button
          className={` px-6 quick-view-action-button `}
          //   onClick={() => handleButtonClick(0)}
        >
          <FaShoppingBag className="quick-view-icon" /> PREOrder
        </button>
      ) : (
        <button
          className={` px-6 quick-view-action-button `}
            onClick={addToCart}
        >
          <FaShoppingBag className="quick-view-icon" /> Add To Bag
        </button>
      )}
      <button
        className={`quick-view-action-button `}
        style={{ backgroundColor: "#e4eaec", color: "black", borderColor: "#e4eaec !important" }}
          onClick={addToWishList}
      >
        <CiHeart
          className="quick-view-icon"
          style={{ color: "black", fontSize: "1.4rem" ,}}
        />
        {isWishlistLoading ? "Loading..." : "Add To Wishlist"}
        
      </button>
      <OverlayTrigger
      placement="right"
      delay={{ show: 250, hide: 400 }}
      overlay={ <Tooltip id="button-tooltip" >
      Share
    </Tooltip>}
    >
      <button
          onClick={copyToClipboard}
        className="border-0"
      >
        <IoShareOutline
          style={{
            fontSize: "2rem",
            color: "var(--primary-color-gentlemenz)",
            fontWeight: 800,
          }}
        />
      </button>
      </OverlayTrigger>
    </div>
  );
};

export default Action;
